<template>
  <div class="card">
    <div class="card-content">
      <div class="header">
        <span class="title is-5">{{ $t('webhooks.error_logs.title') }}</span>
        <div class="tooltip-container">
          <i class="material-icons">&#xE88F;</i>
          <div class="tooltip tooltip-right" role="tooltip">
            <div class="tooltip-arrow"></div>
            <div class="tooltip-inner">
              {{ $t('webhooks.tooltips.error_logs_info') }}
            </div>
          </div>
        </div>
      </div>
      <div class="error-message-container" v-if="errors.length">
        <div
          v-for="(error, index) in errors"
          :key="index"
          class="error-message"
        >
          <div :title="error.timestamp">
            {{ getTime(error.timestamp) }} <span class="divider"></span>
            {{ getDate(error.timestamp) }}
          </div>
          <div class="error-text">{{ error.message }}</div>
          <div class="error-text">{{ getDetails(error) }}</div>
        </div>
      </div>
      <div v-else class="no-errors">
        {{ $t('webhooks.error_logs.no_errors') }}
      </div>
    </div>
  </div>
</template>

<script>
import Api from 'services/Api';
import { mapState } from 'vuex';
import * as moment from 'moment';
import { get } from 'lodash';

export default {
  name: 'ErrorLogs',
  props: {
    errors: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getDetails(error) {
      return get(error, 'data.details', '');
    },
    getDate(date) {
      return moment(date).format('ddd, Do MMM, YYYY');
    },
    getTime(date) {
      return moment(date).format('LT Z');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.card {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: $radius-extra-large;
  box-shadow: 0 2px 4px 0 rgba($black, 0.02), 0 2px 12px 0 rgba($black, 0.06);
}

.card-content {
  padding: 1rem;
  min-height: 72px;
}

.title {
  color: rgba($black, 0.87);
  font-weight: 500;
  font-size: 1.125rem;
  letter-spacing: 0.3px;
  word-wrap: anywhere;
}

.header {
  padding-bottom: 1rem;
}

.no-errors {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.error-message-container {
  max-height: 18rem;
  overflow-y: auto;
}

.error-message {
  font-size: 0.875rem;
  padding: 0.75rem;

  &:nth-child(odd) {
    background-color: $grey-lighter;
  }
}

.error-text {
  padding-top: 0.25rem;
  color: $primary-danger;
}

.divider {
  border-right: 1px solid $grey-light;
  margin: 0 0.5rem 0 0.25rem;
  content: ' ';
}

.tooltip-container {
  display: inline-flex;
  margin-left: 0.5rem;

  .material-icons {
    font-size: 0.8125rem;
  }
}
</style>
